import { render, staticRenderFns } from "./OptIn.vue?vue&type=template&id=df2c2f16&scoped=true&"
import script from "./OptIn.vue?vue&type=script&lang=js&"
export * from "./OptIn.vue?vue&type=script&lang=js&"
import style0 from "./OptIn.vue?vue&type=style&index=0&id=df2c2f16&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df2c2f16",
  null
  
)

export default component.exports